// extracted by mini-css-extract-plugin
export default {"container":"MycawFollowUpTypeformComponent_container__zVAz7","qa":"MycawFollowUpTypeformComponent_qa__6xPi4"};